export default "__VITE_ASSET__DgG1v3Cl__"